import { useQuery } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useDrugStatuses = (drugId?: number) => {
  const { isInitialLoading, data: drugStatuses } = useQuery({
    queryKey: DrugsQueryKeys.drugStatuses(drugId),
    queryFn: () => {
      if (drugId) {
        return DrugsApi.fetchDrugStatusList(Number(drugId));
      }
    },
    enabled: Boolean(drugId),
    staleTime: Infinity,
    retry: false,
  });

  return { isInitialLoading, drugStatuses };
};
